import React from 'react'
import StepWizard, { StepWizardChildProps } from 'react-step-wizard'

import HeadStartIntroStep from './HeadStartIntroStep'

import { WIZARD_STEPS_MAPPING } from 'containers/Apply/LongBeachWizard'
import { updatePercentageAndStep } from 'v2/components/XProgressBar/utils'

interface Props {
    selectedBenefits?: any
    personId?: any
    onFinish: (value: string) => void
    onApplyHeadStart: (value: boolean) => void
    updatePercentage: any
}

const HeadStartWizardContainer: React.FC<Props> = (props: Props & StepWizardChildProps) => {
    const { percentage, wizardStep, childWizzardStep } = updatePercentageAndStep(
        WIZARD_STEPS_MAPPING.benefits,
        WIZARD_STEPS_MAPPING.benefits.headStart,
        WIZARD_STEPS_MAPPING
    )
    props.updatePercentage(percentage, wizardStep, childWizzardStep)
    return (
        <StepWizard
            transitions={{
                enterRight: '',
                enterLeft: '',
                exitRight: '',
                exitLeft: '',
            }}
            isLazyMount={true}
            initialStep={1}
        >
            <HeadStartIntroStep
                onApplyHeadStart={props.onApplyHeadStart}
                personId={props.personId}
                onFinish={props.nextStep}
                onPrevious={props.previousStep}
            />
        </StepWizard>
    )
}

export default HeadStartWizardContainer
